import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "./api";

const AuthCtx = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    const token = localStorage.getItem("fmi_token");
    if (!token) {
      setUser(null);
      setLoading(false);
      return;
    }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      localStorage.removeItem("fmi_token");
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const setAuth = (token, u) => {
    localStorage.setItem("fmi_token", token);
    localStorage.removeItem("fmi_chat_session");
    setUser(u);
  };

  const logout = () => {
    localStorage.removeItem("fmi_token");
    localStorage.removeItem("fmi_chat_session");
    setUser(null);
  };

  return (
    <AuthCtx.Provider value={{ user, setUser, setAuth, logout, refresh, loading }}>
      {children}
    </AuthCtx.Provider>
  );
};

export const useAuth = () => useContext(AuthCtx);
